(() => {
  if (window.__xbCartSnapshotLoaded) return;
  window.__xbCartSnapshotLoaded = true;
  let timer;
  let running = false;
  let pending = false;
  let lastSignature = "";
  function permitted() {
    return window.Shopify?.customerPrivacy?.marketingAllowed?.() === true;
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 600);
  }
  async function sync() {
    if (running) { pending = true; return; }
    if (document.visibilityState === "hidden" || !permitted()) return;
    const client = window.klaviyo;
    if (!client || typeof client.isIdentified !== "function" || typeof client.identify !== "function") return;
    running = true;
    try {
      if (!(await client.isIdentified()) || !permitted()) return;
      const root = window.Shopify?.routes?.root || "/";
      const response = await fetch(root + "cart.js", {credentials:"same-origin", cache:"no-store"});
      if (!response.ok) return;
      const cart = await response.json();
      if (!Array.isArray(cart.items) || !permitted()) return;
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || "nl-NL", {style:"currency",currency:cart.currency || "EUR"}).format(cents / 100);
      const items = cart.items.map(line => ({
        ProductName: String(line.product_title || line.title || ""),
        VariantName: line.variant_title === "Default Title" ? "" : String(line.variant_title || ""),
        Quantity: Number(line.quantity),
        VariantID: String(line.variant_id || line.id),
        ProductURL: new URL(line.url || root + "cart", location.origin).href,
        ImageURL: line.featured_image?.url ? new URL(line.featured_image.url, location.origin).href : line.image ? new URL(line.image, location.origin).href : "",
        Price: Number(line.final_price ?? line.price) / 100,
        PriceDisplay: money(Number(line.final_price ?? line.price)),
        LineTotalDisplay: money(Number(line.final_line_price ?? line.line_price))
      }));
      const signature = JSON.stringify([cart.currency, items]);
      if (signature === lastSignature) return;
      const quantities = new Map();
      for (const item of items) quantities.set(item.VariantID, (quantities.get(item.VariantID) || 0) + item.Quantity);
      const path = [...quantities].map(([id, quantity]) => id + ":" + quantity).join(",");
      const cartURL = location.origin + root + "cart" + (path ? "/" + path + "?storefront=true" : "");
      await client.identify({
        XB_Cart_Ready: true,
        XB_Cart_Items: items,
        XB_Cart_URL: cartURL,
        XB_Cart_Item_Count: Number(cart.item_count),
        XB_Cart_Currency: String(cart.currency || "EUR"),
        XB_Cart_Updated_At: new Date().toISOString()
      });
      lastSignature = signature;
    } catch (_) {
    } finally {
      running = false;
      if (pending) { pending = false; schedule(); }
    }
  }
  if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, schedule);
    subscribe(PUB_SUB_EVENTS.cartDrawerOpen, schedule);
  }
  document.addEventListener("visitorConsentCollected", schedule);
  document.addEventListener("visibilitychange", schedule);
  window.addEventListener("pageshow", schedule);
  document.addEventListener("klaviyoForms", schedule);
  schedule();
  setTimeout(schedule, 3000);
})();